import React, { useState } from 'react'
import { toast } from 'react-toastify'

import { Theme, Typography, IconButton } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import { ListVendor } from '../../models'
import { Container, SideDrawer } from '../../components'
import { WorkspaceUserList } from '../../components/AdminPanel/WorkspaceModal/WorkspaceUserList'
import { UserState } from '../../components/AdminPanel/WorkspaceModal/SelectedWorkspacePanel'
import { axiosInstance } from '../../helpers'

interface Props {
    theme: Theme
    vendor: ListVendor
    vendorUserState: UserState
    openVendorUserDrawer: boolean
    setOpenVendorUserDrawer: (open: boolean) => void
    setVendorUserState: React.Dispatch<React.SetStateAction<UserState>>
}

export const AddVendorUser = (props: Props) => {
    const {
        theme,
        vendor,
        vendorUserState,
        openVendorUserDrawer,
        setOpenVendorUserDrawer,
        setVendorUserState,
    } = props

    const resendWelcomeEmail = async (email: string) => {
        const body = {
            email: email,
        }
        axiosInstance
            .post(`user/resend_welcome_email/`, body)
            .then(() => {
                toast.success(`Welcome email resent!`)
            })
            .catch((e) => {
                toast.error(e.response.data.message)
            })
    }

    const handleCreate = (email: string, name?: string) => {
        axiosInstance
            .post(`company/vendor/${vendor.id}/add_vendor_user/`, {
                email: email,
                name: name,
            })
            .then((res) => {
                setVendorUserState((prev) => {
                    return {
                        ...prev,
                        userList: [...prev.userList, res.data],
                    }
                })

                toast.success(`User Added`)
            })
            .catch(() => {
                toast.error(`User not found`)
            })
    }

    return (
        <SideDrawer
            open={openVendorUserDrawer}
            width={360}
            handleClose={() => setOpenVendorUserDrawer(false)}
            header={
                <Container
                    style={{
                        padding: theme.spacing(1),
                        display: 'flex',
                        alignItems: 'center',
                        gap: theme.spacing(1),
                    }}
                >
                    <IconButton
                        size="small"
                        onClick={() => setOpenVendorUserDrawer(false)}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6">{vendor.name}</Typography>
                </Container>
            }
        >
            <WorkspaceUserList
                theme={theme}
                userState={vendorUserState}
                handleCreate={handleCreate}
                handleResendWelcomeEmail={resendWelcomeEmail}
                needUserName
            />
        </SideDrawer>
    )
}
